import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-6" }
const _hoisted_3 = { class: "col-12 col-md-6" }
const _hoisted_4 = { class: "col-12 col-md-6" }
const _hoisted_5 = { class: "col-12 col-md-6" }
const _hoisted_6 = { class: "col-12 col-md-6" }
const _hoisted_7 = { class: "col-12 col-md-6" }
const _hoisted_8 = { class: "col-12 col-md-6" }
const _hoisted_9 = { class: "col-12 col-md-6" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = ["value", "onBlur", "onFocus"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Укажите дату документа ", -1)
const _hoisted_13 = { class: "col-12 col-md-6" }
const _hoisted_14 = { class: "col-12 mt-3" }
const _hoisted_15 = { class: "col-12 text-center mt-3" }

import { onMounted, reactive, computed, ref } from "vue";
import { IUser } from '@/@types/IUser';
import { useModal } from "@/composables/useModal";
import api from "@/api";
import { ISupplier } from "@/@types/ISupplier";
import { ILocomotive } from "@/@types/ILocomotive";
import { userStore } from "@/store/userStore";
import { IDocumentSubtype, IDocumentType } from "@/@types/IDocument";
import { DatePicker } from 'v-calendar';

type stateType = {
    id: number,
    visibleErrors: boolean,
    loader: boolean,
    documentId: number,
    documentTypeId: null | number,
    documentNumber: string,
    documentNames: string[],
    userAccesses: number[],
    subtypeId: null | number,
    name: string,
    locomotiveId: number | string,
    documentType: string,
    contractorId: null | number,
    tags: Array<string>,
    comment: string,
    documentedAt: string,
};


export default /*#__PURE__*/_defineComponent({
  __name: 'EditDocumentModal',
  props: {
    id: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props;

const modal = useModal(props.id);
const contractors = ref<ISupplier[]>([]);
const locomotives = ref<ILocomotive[]>([]);
const documentTypes = ref<IDocumentType[]>([]);
const { user } = userStore();
const users = ref<Array<IUser>>();
const state: stateType = reactive({
    id: 0,
    visibleErrors: false,
    loader: false,
    name: '',
    documentType: '',
    documentNames: [],
    userAccesses: [],
    documentNumber: '',
    documentTypeId: null,
    subtypeId: null,
    documentId: 0,
    locomotiveId: '',
    contractorId: null,
    tags: [],
    comment: '',
    documentedAt: '',
});

const filteredLocomotives = computed(() => {
    if (!state.contractorId) {
        return [];
    }

    const contractor = contractors.value.find(c => c.id === state.contractorId);

    if (!contractor) {
        return [];
    }

    return locomotives.value.filter(locomotive => locomotive.contractorId === Number(contractor.rollingStockOwner?.id));
});

const filteredSubtypes = computed(() => {
    if (!state.documentTypeId) {
        return [];
    }

    const selectedDocumentType = documentTypes.value.find(dt => dt.id === state.documentTypeId);
    if (!selectedDocumentType) {
        return [];
    }

    return selectedDocumentType.subTypes;
});

onMounted(() => {
    if (Object.keys(modal.data.document).length) {
        state.documentId = modal.data.document.id;
        state.tags = modal.data.document.tags;
        state.documentNames = modal.data.documentNames;
        state.contractorId = modal.data.document.contractorId;
        state.subtypeId = modal.data.document.subTypeId;
        state.name = modal.data.document.fileName;
        state.comment = modal.data.document.comment;
        state.documentedAt = modal.data.document.documentedAt;
        state.documentNumber = modal.data.document.documentNumber;
        state.userAccesses = modal.data.document.userAccesses.map(access => access.userId);
    }

    api.supplier.get().then(r => {
        contractors.value = r.data;
    });

    api.user.getAll().then((r) => {
        users.value = r.data.filter((r: IUser) => r.id !== user.id);
    });

    api.document.getTypes().then(r => {
        documentTypes.value = r.data;
        if (!state.subtypeId) {
            return;
        }
        const type = r.data.find((type: IDocumentType) => {
            return type.subTypes.some((s: IDocumentSubtype) => s.id === state.subtypeId);
        });
        if (!type) {
            return;
        }
        state.documentTypeId = type.id;
    });

    api.locomotives.getAll().then(data => {
        locomotives.value = data;
    }).catch(console.error);
});

const isNameError = computed(() => !state.name.length || !/[\wа-яА-Я]+/ig.test(state.name) || state.documentNames.includes(state.name));
const isDocumentTypeError = computed(() => !state.documentTypeId);
const isDocumentSubTypeError = computed(() => !state.subtypeId);
const isDocumentNumberError = computed(() => !state.documentNumber);
const isDocumentedAtError = computed(() => !state.documentedAt);

const isErrorsExist = computed(() => isDocumentTypeError.value ||
    isNameError.value ||
    isDocumentNumberError.value ||
    isDocumentedAtError.value ||
    isDocumentSubTypeError.value);

function onSupplierSelected(supplier: ISupplier) {
    state.locomotiveId = '';
    if (state.contractorId === supplier.id) {
        state.contractorId = null;
    } else {
        state.contractorId = supplier.id;
    }
}

function onDocumentTypeSelected(documentType: IDocumentType) {
    state.subtypeId = null;
    if (state.documentTypeId === documentType.id) {
        state.documentTypeId = null;
    } else {
        state.documentTypeId = documentType.id;
    }
}

function onDocumentSubTypeSelected(documentType: IDocumentType) {
    if (state.subtypeId === documentType.id) {
        state.subtypeId = null;
    } else {
        state.subtypeId = documentType.id;
    }
}

function handleLocomotiveSelect(locomotive: ILocomotive) {
    if (state.locomotiveId === locomotive.id) {
        state.locomotiveId = '';
    } else {
        state.locomotiveId = locomotive.id;
    }
}

function handleUserAccessSelect(users: Array<IUser>) {
    state.userAccesses = users.map(user => user.id);
}

function handleChangeTag(tags: Array<string>) {
    state.tags = tags;
}

function send() {
    if (isErrorsExist.value) {
        state.visibleErrors = true;
        return;
    }
    state.visibleErrors = false;
    state.loader = true;

    api.document.update(state.documentId, {
        documentType: state.documentType,
        tags: state.tags,
        name: state.name,
        contractorId: state.contractorId,
        locomotiveId: state.locomotiveId || null,
        subtypeId: state.subtypeId,
        comment: state.comment,
        documentedAt: state.documentedAt,
        documentNumber: state.documentNumber,
        users: state.userAccesses,
    }).then(r => {
        modal.ok(r.data);
    });
}


return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_tags_input_ui = _resolveComponent("tags-input-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-md",
    title: "Редактирование документа"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Тип не указан",
              label: "Тип документа",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": state.visibleErrors && isDocumentTypeError.value,
                  "item-key": "name",
                  options: documentTypes.value,
                  placeholder: "Тип документа",
                  searchable: true,
                  values: [state.documentTypeId],
                  onOnSelected: onDocumentTypeSelected
                }, null, 8, ["is-invalid", "options", "values"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Подтип не указан",
              label: "Подтип документа",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  disabled: !state.documentTypeId,
                  "is-invalid": state.visibleErrors && isDocumentSubTypeError.value,
                  "item-key": "name",
                  options: filteredSubtypes.value,
                  placeholder: "Подтип документа",
                  searchable: true,
                  values: [state.subtypeId],
                  onOnSelected: onDocumentSubTypeSelected
                }, null, 8, ["disabled", "is-invalid", "options", "values"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите номер",
              label: "Номер документа",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.documentNumber,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.documentNumber) = $event)),
                  "is-invalid": state.visibleErrors && isDocumentNumberError.value,
                  placeholder: "Номер документа"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите наименование",
              label: "Наименование",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.name) = $event)),
                  "is-invalid": state.visibleErrors && isNameError.value,
                  placeholder: "Наименование"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_form_group_ui, { label: "Контрагент" }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "item-key": "name",
                  options: contractors.value,
                  placeholder: "Контрагент",
                  searchable: true,
                  values: [state.contractorId],
                  onOnSelected: onSupplierSelected
                }, null, 8, ["options", "values"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_form_group_ui, {
              label: "Локомотив",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  disabled: !state.contractorId,
                  "item-key": "name",
                  options: filteredLocomotives.value,
                  placeholder: "Локомотив",
                  searchable: true,
                  values: [state.locomotiveId],
                  onOnSelected: handleLocomotiveSelect
                }, null, 8, ["disabled", "options", "values"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_form_group_ui, {
              label: "Доступ",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "item-key": "login",
                  multiple: true,
                  options: users.value,
                  placeholder: "Доступ",
                  searchable: true,
                  values: state.userAccesses,
                  onOnUpdated: handleUserAccessSelect
                }, null, 8, ["options", "values"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите дату документа",
              label: "Дата документа",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DatePicker), {
                  modelValue: state.documentedAt,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.documentedAt) = $event)),
                  class: "inline-block h-full",
                  is24hr: true,
                  mode: "date",
                  timezone: 'Asia/Almaty'
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-invalid': isDocumentedAtError.value && state.visibleErrors, 'bg-white': true }]),
                        value: inputValue,
                        onBlur: ($event: any) => (togglePopover()),
                        onFocus: ($event: any) => (togglePopover())
                      }, null, 42, _hoisted_11),
                      _hoisted_12
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_form_group_ui, { label: "Краткое содержание" }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.comment,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.comment) = $event)),
                  placeholder: "Краткое содержание"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_tags_input_ui, {
              placeholder: "Тэги",
              tags: state.tags,
              onOnTagsChanged: handleChangeTag
            }, null, 8, ["tags"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
            default: _withCtx(() => [
              _createTextVNode(" Сохранить ")
            ]),
            _: 1
          })
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id"]))
}
}

})